module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "newPriceContainer"
  }, [(_vm.data.length == 1) ? [_c('i', {
    staticClass: "icon-wallet icons text-green big-icon"
  }), _vm._v(" "), _c('p', {
    staticClass: "price has-text-right"
  }, [_vm._v("\n      USD $" + _vm._s(_vm.data[0].number) + "\n    ")])] : [_c('i', {
    staticClass: "icon-wallet icons text-green big-icon"
  }), _vm._v(" "), _vm._l((_vm.data), function(price) {
    return [(price.type == 2) ? _c('p', {
      staticClass: "price has-text-right"
    }, [_vm._v("\n        USD $" + _vm._s(price.number) + "\n      ")]) : _vm._e(), _vm._v(" "), (price.type == 1) ? _c('p', {
      staticClass: "price discount has-text-right"
    }, [_vm._v("\n        USD $" + _vm._s(price.number) + "\n      ")]) : _vm._e()]
  }), _vm._v(" "), _c('p', {
    staticClass: "price aux"
  }, [_vm._v("*o el cambio a tu moneda local")])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74416b58","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/new-price/component.vue
// module id = 419
// module chunks = 1